export default __webpack_public_path__ + "static/media/JoinIcon.e450f79a.svg";